import { render } from "./rejection-log.vue?vue&type=template&id=a8cb2180&scoped=true"
import script from "./rejection-log.vue?vue&type=script&lang=js"
export * from "./rejection-log.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./rejection-log.vue?vue&type=style&index=1&id=a8cb2180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8cb2180"]])

export default __exports__